<template>
	<div
		v-if="pagination.total > pagination.pageSize"
		class="pagination"
	>
		<el-pagination
			:total="pagination.total"
			:current-page.sync="pagination.currentPage"
			@current-change="changePage"
			@prev-click="changePage(pagination.currentPage - 1)"
			@next-click="changePage(pagination.currentPage + 1)"
			:page-size="pagination.pageSize"
			layout="prev, pager, next"
			background
		/>
	</div>
</template>

<script>
import { EventBus } from '@/services/event-bus'

export default {
    name: 'SearchPagination',
	props: {
		pagination: Object
	},
	methods: {
		changePage (page) {
			EventBus.$emit('change-pagination', page)
		}
	}
}
</script>

<style lang="scss" scoped>
.pagination {
	@include flex(flex, row, wrap, flex-end, center);
	margin-top: 20px;
}
</style>
